import { Editor, Path } from 'slate';

class PathUtils {
  static sortPathsByDepth(paths: Path[], reverse = false) {
    const sortedPaths = [...paths];

    sortedPaths.sort((a, b) => {
      const res = Path.compare(a, b);
      if (res === 0) return a.length - b.length;
      return res;
    });

    if (reverse) {
      sortedPaths.reverse();
    }

    return sortedPaths;
  }

  static hasNext = (editor: Editor, path: Path): boolean => {
    const parentEntry = Editor.parent(editor, path);
    if (!parentEntry) return false;

    const [parent] = parentEntry;
    return parent.children.length > path[path.length - 1] + 1;
  };

  // hasPrevious is just a thin wrapper aound the Path method,
  // added here for symmetry with the hasNext method.
  static hasPrevious = (editor: Editor, path: Path): boolean => {
    return Path.hasPrevious(path);
  };

  static previousSiblingPath = (path: Path): Path => {
    return path.toSpliced(-1, 1, path[path.length - 1] - 1);
  };

  static nextSiblingPath = (path: Path): Path => {
    return path.toSpliced(-1, 1, path[path.length - 1] + 1);
  };
}

export default PathUtils;
